export default "__VITE_ASSET__C$7rx0PF__"